import { Icon as ScaleUIIcon, Typography } from '@scale/scaleui';
import { Badge, Flex } from '@scale/scaleui-radix';

interface ChatBulkAuditEditSummaryViewProps {
  editedStepList: string[] | undefined;
}

const parseStepInfo = (stepString: string): { stepNumber: string; stepName: string } => {
  const match = stepString.match(/^\[(\d+)\]\s+(.+)$/);
  if (match) {
    return {
      stepNumber: match[1],
      stepName: match[2],
    };
  }
  return {
    stepNumber: '',
    stepName: stepString,
  };
};

// take in a string that could contain camel or snake case and return the string in sentence case
const toSentenceCase = (str: string): string => {
  const spaced = str.replace(/([A-Z])/g, ' $1');
  const withoutUnderscores = spaced.replace(/_/g, ' ');
  return withoutUnderscores.trim().replace(/^./, function (firstChar) {
    return firstChar.toUpperCase();
  });
};

export const ChatBulkAuditEditSummaryView = ({
  editedStepList,
}: ChatBulkAuditEditSummaryViewProps) => {
  if (!editedStepList || editedStepList.length === 0) {
    return null;
  }
  return (
    <div className="mx-2">
      <Typography.Overline3 className="mb-2">
        {editedStepList.length === 1
          ? '1 step was changed from the original task'
          : `${editedStepList.length} steps were changed from the original task`}
      </Typography.Overline3>
      <div className="mt-2 overflow-x-auto">
        <Flex direction="row" gap="2" wrap="nowrap">
          {editedStepList.map((step, index) => {
            const { stepNumber, stepName } = parseStepInfo(step);
            const tooltipText = stepNumber
              ? `Step ${stepNumber} (${toSentenceCase(stepName)}) was modified`
              : `${toSentenceCase(stepName)} was modified`;
            return (
              <Badge key={index} color="blue" size="sm">
                <ScaleUIIcon icon="info-circle" size="sm" tooltip={tooltipText} />
                <Typography.Overline3>{toSentenceCase(stepName)}</Typography.Overline3>
              </Badge>
            );
          })}
        </Flex>
      </div>
    </div>
  );
};
